import React, { Component } from "react";
import { connect } from "react-redux";
import { Wrapper } from "./style.js";

export default class Header extends Component {
  render() {
    const { title, className } = this.props;
    return <Wrapper className={className}>{title}</Wrapper>;
  }
}



// WEBPACK FOOTER //
// ./src/pages/MagnetReport/components/Header/index.jsx